exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item {\n  display: block;\n  margin: 5px 0;\n  padding: 5px 15px;\n  font-family: Times;\n  font-size: 1.5em;\n  border: 0;\n  outline: none !important;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n  .item .tag {\n    color: #6858a4; }\n\n.item-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  .item-container:hover nav {\n    visibility: visible; }\n  .item-container nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow: hidden;\n    visibility: hidden; }\n    .item-container nav a {\n      display: inline-block;\n      margin: auto;\n      padding: 5px; }\n      .item-container nav a:hover {\n        cursor: pointer;\n        color: #E15554; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/Item.component.sass
// module id = ../../../../../src/app/items/Item.component.sass
// module chunks = main